/**
 * AreaShiftTable — Areas by Shift breakdown (Day/Evening/Night).
 */

const AreaShiftTable = ({ data }) => {
    const rows = Array.isArray(data) ? data : [];

    return (
        <div className="md-section">
            <h3 className="md-section__title" style={{ marginBottom: 'var(--space-4)' }}>Areas by Shift</h3>
            <div className="dp-table-wrap">
                <table className="dp-table">
                    <thead className="dp-thead">
                        <tr>
                            <th className="dp-th" rowSpan={2}>Area Type</th>
                            <th className="dp-th md-shift--day" colSpan={2} style={{ textAlign: 'center' }}>
                                <span className="md-shift-label">Day</span>
                            </th>
                            <th className="dp-th md-shift--evening" colSpan={2} style={{ textAlign: 'center' }}>
                                <span className="md-shift-label">Evening</span>
                            </th>
                            <th className="dp-th md-shift--night" colSpan={2} style={{ textAlign: 'center' }}>
                                <span className="md-shift-label">Night</span>
                            </th>
                        </tr>
                        <tr>
                            <th className="dp-th md-shift--day" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Daily</th>
                            <th className="dp-th md-shift--day" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Resp (min)</th>
                            <th className="dp-th md-shift--evening" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Daily</th>
                            <th className="dp-th md-shift--evening" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Resp (min)</th>
                            <th className="dp-th md-shift--night" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Daily</th>
                            <th className="dp-th md-shift--night" style={{ textAlign: 'center', fontSize: 'var(--font-size-xs)' }}>Avg Resp (min)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr className="dp-tr"><td className="dp-td" colSpan={7} style={{ textAlign: 'center' }}><span className="dp-cell-text dp-cell-text--muted">No shift data</span></td></tr>
                        ) : null}
                        {rows.map((r, i) => (
                            <tr key={i} className="dp-tr">
                                <td className="dp-td" style={{ fontWeight: r.area_type_name === 'Totals' ? 600 : 'normal' }}>{r.area_type_name || '—'}</td>
                                <td className="dp-td md-shift--day" style={{ textAlign: 'center' }}>{r.avg_daily_events_1st ?? '-'}</td>
                                <td className="dp-td md-shift--day" style={{ textAlign: 'center' }}>{r.avg_response_time_1st ?? '-'}</td>
                                <td className="dp-td md-shift--evening" style={{ textAlign: 'center' }}>{r.avg_daily_events_2nd ?? '-'}</td>
                                <td className="dp-td md-shift--evening" style={{ textAlign: 'center' }}>{r.avg_response_time_2nd ?? '-'}</td>
                                <td className="dp-td md-shift--night" style={{ textAlign: 'center' }}>{r.avg_daily_events_3rd ?? '-'}</td>
                                <td className="dp-td md-shift--night" style={{ textAlign: 'center' }}>{r.avg_response_time_3rd ?? '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AreaShiftTable;
